<script lang="ts">
  import { goto } from '$app/navigation';
  import { page } from '$app/stores';
  import Button from '$components/reusable/Button.svelte';
  import SlideOver from '$components/reusable/SlideOver.svelte';
  import GlobeIcon from '$icons/GlobeIcon.svelte';
  import LuggageIcon from '$icons/LuggageIcon.svelte';
  import MessageBubbleIcon from '$icons/MessageBubbleIcon.svelte';
  import PinIcon from '$icons/PinIcon.svelte';
  import ArrowTopRight from '$icons/arrows/ArrowTopRight.svelte';
  import GithubLogo from '$icons/logos/GithubLogo.svelte';
  import LinkedInLogo from '$icons/logos/LinkedInLogo.svelte';
  import TelegramLogo from '$icons/logos/TelegramLogo.svelte';
  import XLogo from '$icons/logos/XLogo.svelte';
  import type { RetrieveProfileResponse } from '$shared/api';
  import UserCard from './UserCard.svelte';
  import UserProfileContent from './UserProfileContent.svelte';

  export let previewedUser: RetrieveProfileResponse | null = null;
  export let open = false;
  export let openMessageModal: () => void;
</script>

<SlideOver bind:slideOverOpen={open} title="// View Profile">
  {#if previewedUser}
    <div class="h-full overflow-y-scroll">
      <div
        class="border-gray-dark-6 p-3xs hover:border-gray-dark-9 hover:bg-gray-dark-1 w-full rounded border"
      >
        <div
          class="border-gray-dark-2 p-md text-gray-dark-11 w-full rounded border text-xs leading-4"
        >
          <!-- Details -->
          <UserCard
            profile={{
              displayName: previewedUser.profile.displayName,
              username: previewedUser.profile.username,
              avatarUrl: previewedUser.profile.avatarUrl,
              accountRoles: previewedUser.profile.accountRoles,
              batches: previewedUser.profile.batches,
            }}
          />
          <div class="my-lg gap-y-md flex w-full flex-col items-start">
            {#if previewedUser.extendedProfile.currentPosition}
              <div class="flex items-center gap-x-2">
                <LuggageIcon />
                <span>{previewedUser.extendedProfile.currentPosition}</span>
              </div>
            {/if}
            {#if previewedUser.extendedProfile.city || previewedUser.extendedProfile.country}
              <div class="flex items-center gap-x-2">
                <PinIcon />
                <span
                  >{previewedUser.extendedProfile.city ?? ''}, {previewedUser.extendedProfile
                    .country ?? ''}</span
                >
              </div>
            {/if}
            {#if previewedUser.extendedProfile.languages?.length}
              <div class="flex items-center gap-x-2">
                <GlobeIcon />
                <span>{previewedUser.extendedProfile.languages.join(', ')}</span>
              </div>
            {/if}
          </div>
          <div class="mt-lg gap-md flex flex-col sm:flex-row">
            {#if previewedUser.profile.username != $page.data.username}
              <Button secondary class="min-h-[32px] flex-1" on:click={openMessageModal}>
                <MessageBubbleIcon slot="left-icon" />
                <span>message</span>
              </Button>
            {/if}
            <Button
              tertiary
              class="min-h-[32px] flex-1"
              on:click={() => goto(`/profiles/${previewedUser.profile.username}`)}
            >
              <ArrowTopRight slot="left-icon" />
              <span>View full profile</span>
            </Button>
          </div>
          <div class="mt-3 flex items-center gap-x-2">
            {#if previewedUser.extendedProfile.telegramHandle}
              <Button
                target="_blank"
                href={`https://t.me/${previewedUser.extendedProfile.telegramHandle}`}
                quinary
                size="sm"
                icon><TelegramLogo /></Button
              >
            {/if}
            {#if previewedUser.extendedProfile.githubHandle}
              <Button
                target="_blank"
                href={`https://github.com/${previewedUser.extendedProfile.githubHandle}`}
                quinary
                size="sm"
                icon><GithubLogo /></Button
              >
            {/if}
            {#if previewedUser.extendedProfile.twitterHandle}
              <Button
                target="_blank"
                href={`https://twitter.com/${previewedUser.extendedProfile.twitterHandle}`}
                quinary
                size="sm"
                icon><XLogo /></Button
              >
            {/if}
            {#if previewedUser.extendedProfile.linkedinHandle}
              <Button
                target="_blank"
                href={`${previewedUser.extendedProfile.linkedinHandle.startsWith('http') ? '' : 'https://'}${
                  previewedUser.extendedProfile.linkedinHandle
                }`}
                quinary
                size="sm"
                icon><LinkedInLogo /></Button
              >
            {/if}
          </div>
        </div>
      </div>
      <UserProfileContent
        profile={previewedUser}
        isOwnProfile={previewedUser.profile.username === $page.data.username}
      />
    </div>
  {/if}
</SlideOver>
